import { render, staticRenderFns } from "./task-quick-review-table.vue?vue&type=template&id=4d729794&scoped=true&"
import script from "./task-quick-review-table.vue?vue&type=script&lang=js&"
export * from "./task-quick-review-table.vue?vue&type=script&lang=js&"
import style0 from "./task-quick-review-table.vue?vue&type=style&index=0&id=4d729794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d729794",
  null
  
)

export default component.exports